import type { AcpPlanEntryData } from '@crowdex/agent-contracts';

export function planProgressIndex(entries: readonly AcpPlanEntryData[]): number {
  if (entries.length === 0) return -1;
  const activeIndex = entries.findIndex((entry) => entry.status === 'in_progress');
  if (activeIndex >= 0) return activeIndex;
  const pendingIndex = entries.findIndex((entry) => entry.status === 'pending');
  return pendingIndex >= 0 ? pendingIndex : entries.length - 1;
}
